import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AwarenessTagManagerEvents } from "../utils/GoogleTagManager";
import { sha256Hash } from "../utils/CommonFunction";
import { setCookie } from "../utils/CommonFunction";

import SubscriptionSuccesPopUp from "../components/landing_comp/SubscriptionSuccesPopUp";
import FailurePopUp from "../components/landing_comp/FailurePopUp";
import Loader from "../components/loader";
const JazzCashFallbackScreen = () => {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const status = searchParams.get("status") ? searchParams.get("status") : "1";
  const message = searchParams.get("message")
    ? searchParams.get("message")
    : "";
  const plan_id = searchParams.get("plan_id")
    ? searchParams.get("plan_id")
    : "1";
  const token = searchParams.get("token") ? searchParams.get("token") : "";
  const msisdn = searchParams.get("msisdn") ? searchParams.get("msisdn") : "";
  const utm_source = searchParams.get("utm_source")
    ? searchParams.get("utm_source")
    : "";

  const [loading, setLoading] = useState(true);

  const [showJazzCashFailurePoUp, setShowJazzCashFailurePopUp] =
    useState<boolean>(false);

  const [showJazzCashSuccessPopUp, setShowJazzCashSuccessPopUp] =
    useState(false);

  useEffect(() => {
    console.log("run", status);
    console.log(typeof status, message, token, msisdn);
    if (status === "0") {
      if (utm_source) {
        AwarenessTagManagerEvents({
          event: "subscribe_jazzcash",
          utm_source: utm_source,
          plan_id: plan_id,
          phone_number: sha256Hash("+92" + msisdn?.slice(-10)),
          external_id: sha256Hash("tp" + msisdn?.slice(-10)),
        });
      }
      setTimeout(() => {
        setLoading(false);
        console.log(">>>>>>>>>>>>> poup for success");
        if (token && msisdn) {
          setCookie(msisdn.slice(-10), token, "");
        }
        setShowJazzCashSuccessPopUp(true);
      }, 1200);
    } else {
      console.log("else case if status is 1:: ===>>", status);
      setLoading(false);
      setShowJazzCashFailurePopUp(true);
    }
  }, []);

  const hideFailureJazzCashPopUp = () => {
    setShowJazzCashFailurePopUp(false);
    // navigate(RouteNames.home);
    window.location.replace("/home");
  };

  const onHidejcSuccessModal = () => {
    setShowJazzCashSuccessPopUp(false);
    // navigate(RouteNames.home);
    window.location.replace("/home");
  };

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <>
      {showJazzCashSuccessPopUp && (
        <SubscriptionSuccesPopUp onHidejcSuccessModal={onHidejcSuccessModal} />
      )}
      {showJazzCashFailurePoUp && (
        <FailurePopUp
          message={message ?? ""}
          onClose={hideFailureJazzCashPopUp}
        />
      )}
    </>
  );
};

export default JazzCashFallbackScreen;
